import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { AlertCircle } from 'lucide-react';
export function PainPoints() {
  const points = ["Amaneces cansada aunque 'dormiste'.", 'Te portas bien todo el día y a las 9pm te gana el picoteo.', 'Sientes tu barriga más dura/inflamada al final de la tarde.', 'Te frustras porque lo que antes funcionaba ahora no.'];
  return <Section background="cream" data-id="element-86">
      <h2 className="text-3xl font-bold text-center text-[#2C2C2C] mb-12" data-id="element-87">
        La situación (lo que vives a diario)
      </h2>

      <div className="bg-white rounded-2xl shadow-sm p-8 md:p-12" data-id="element-88">
        <ul className="space-y-6 mb-10" data-id="element-89">
          {points.map((point, index) => <motion.li key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start" data-id="element-90">
              <div className="flex-shrink-0 h-6 w-6 rounded-full bg-[#FCEBE8] flex items-center justify-center mt-1 mr-4" data-id="element-91">
                <div className="h-2 w-2 rounded-full bg-[#D4735E]" data-id="element-92"></div>
              </div>
              <span className="text-lg text-[#5A5A5A]" data-id="element-93">{point}</span>
            </motion.li>)}
        </ul>

        <div className="border-t border-gray-100 pt-8 text-center" data-id="element-94">
          <p className="text-[#5A5A5A] mb-4" data-id="element-95">
            Y lo peor: te dices cosas que no le dirías a nadie:
          </p>
          <div className="flex flex-col md:flex-row justify-center gap-4 text-[#8B9D83] font-medium italic" data-id="element-96">
            <span data-id="element-97">"¿Qué me pasa?"</span>
            <span className="hidden md:inline" data-id="element-98">•</span>
            <span data-id="element-99">"¿Por qué no puedo sostenerme?"</span>
            <span className="hidden md:inline" data-id="element-100">•</span>
            <span data-id="element-101">"¿Será que ya me quedé así?"</span>
          </div>
        </div>
      </div>
    </Section>;
}